import http, { getTenantFromUrl } from "../helpers/http";

export const getOrganisations = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/Organisation/all?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const createOrganisation = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Organisation created (Mock)", data: {} };
  }
  const response = await http().post("/Organisation/create", payload);
  return response.data;
};

export const updateOrganisation = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Organisation updated (Mock)", data: {} };
  }
  const response = await http().post("/Organisation/update", payload);
  return response.data;
};

export const fetchRequests = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/Organisation/pending-requests?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const approveRequests = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Request approved (Mock)", data: {} };
  }
  const response = await http().post("/Organisation/approve-requests", payload);
  return response.data;
};

export const fetchInactiveRequests = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/Organisation/inactive-organisations?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const activateRequests = async (id, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Request activated (Mock)", data: {} };
  }
  const response = await http().post(
    `/Organisation/activate-organisation?id=${id}`
  );
  return response.data;
};

export const fetchRefundRequests = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/Refund/paginated?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const approveRefundRequests = async (body, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Refund approved (Mock)", data: {} };
  }
  const response = await http().post(
    `/Refund/process/by-refund/${body.id}`, body.data
  );
  return response.data;
};

export const fetchManualPendingRefunds = async (tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get("/Refund/manual/pending");
  return response.data;
};

export const fetchPendingRefunds = async (tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get("/Refund/pending");
  return response.data;
};

export const fetchInProgressRefunds = async (tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get("/Refund/in-progress");
  return response.data;
};

export const fetchApprovedRefunds = async (tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get("/Refund/approved");
  return response.data;
};

export const fetchDeclinedRefunds = async (tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get("/Refund/declined");
  return response.data;
};

export const escalateRefundManual = async (refundId, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Refund escalated (Mock)", data: {} };
  }
  const response = await http().post(`/Refund/manual/escalate/${refundId}`);
  return response.data;
};

export const checkRefundStatusQr = async (refundId, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Status checked (Mock)", data: {} };
  }
  const response = await http().get(`/Refund/check-status-qr?refundId=${refundId}`);
  return response.data;
};

export const resolveRefundRequest = async (refundId, payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Refund request resolved (Mock)", data: {} };
  }
  const response = await http().post(`/Refund/${refundId}/resolve`, payload);
  return response.data;
};

export const fetchGlobalSubscriptions = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/admin/subscriptions?page=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};

export const fetchNetworkSummary = async (pageNumber, pageSize, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, data: [], result: [], count: 0, totalPages: 0 };
  }
  const response = await http().get(
    `/admin/subscriptions/network-summary?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.data;
};
